import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-allocation-reports',
  templateUrl: './allocation-reports.component.html',
  styleUrls: ['./allocation-reports.component.css']
})
export class AllocationReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/allocation-reports/allocation-reports.component.ts